module.exports = __webpack_public_path__ + "static/media/Herbert Hoover - 1928.de6ddb7b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/Herbert Hoover - 1928.jpg
// module id = 490
// module chunks = 0